import { AuthContext } from "auth"
import { useContext } from "react"
import {Navigate, useLocation } from "react-router-dom";
export const PrivateRoute=({children}) =>{
    
    const {logged}=useContext(AuthContext);
    const {pathname,search} =useLocation();
    const lastPath=pathname+search;
    if(lastPath!='/ActualizarContrasena'){
       
        localStorage.setItem('lastPath',lastPath);
    }
    
    return (logged) ? children: <Navigate replace to="/login" />
}